import moment from 'moment';

export const isMoneyTicketDeadlineOverdue = (
	deadline: string | null,
): boolean => {
	if (!deadline) {
		return false;
	}

	return moment(deadline, 'DD.MM.YYYY')
		.startOf('day')
		.isBefore(moment().startOf('day'));
};
